import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import Select from 'components/forms/Select';

import { resultsToOptions } from 'utils/misc';
import { CAMPAIGN_MANAGER } from 'constants/misc';
import { AbilityContext, hasUserGroup } from 'utils/permissions';

import { getAccounts } from 'redux/actions/accountActions';


class AccountsFilter extends Component {
  static propTypes = {
    value: PropTypes.shape({}).isRequired,
    onChange: PropTypes.func.isRequired,
    user: PropTypes.shape({
      pk: PropTypes.number,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      isAuthenticated: PropTypes.bool,
      user_groups: PropTypes.array,
    }).isRequired,
    accounts: PropTypes.shape({
      results: PropTypes.shape({}.isRequired),
    }).isRequired,
    getAccounts: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const {
      user: { user_groups: userGroups },
    } = this.props;
    if (this.context.can('see', 'Manager')) {
      this.props.getAccounts();
    } else if (hasUserGroup(userGroups, [CAMPAIGN_MANAGER])) {
      this.props.getAccounts({ campaign__campaign_manager__id: this.props.user.pk, status: 'true' });
    } else {
      this.props.getAccounts({ status: 'true' });
    }
  }

  handleLoadOptions = async (filterString) => {
    await this.props.getAccounts({ search: filterString, status: true });
    return resultsToOptions(this.props.accounts.results, 'name') || [];
  }

  render() {
    const { value, onChange } = this.props;
    return (
      <Select
        isMulti
        placeholder="Accounts"
        value={value}
        onChange={onChange}
        cacheOptions
        defaultOptions
        loadOptions={this.handleLoadOptions}
      />
    );
  }
}

AccountsFilter.contextType = AbilityContext;

export default compose(connect(
  state => ({
    accounts: state.accounts,
    user: state.user,
  }),
  { getAccounts },
))(AccountsFilter);
